export default {
  /** 共通 */
  'pages.common.required': 'Please Enter',

  /** ログイン */
  'pages.layouts.userLayout.title':
    ' ',
  // 'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect userid/password',
  'pages.login.failure': 'Login failed, please try again',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'User ID',
  'pages.login.username.required': 'Please input your userid',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password',
  // 'pages.login.phoneLogin.tab': 'Phone Login',
  // 'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  // 'pages.login.phoneNumber.placeholder': 'Phone Number',
  // 'pages.login.phoneNumber.required': 'Please input your phone number!',
  // 'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  // 'pages.login.captcha.placeholder': 'Verification Code',
  // 'pages.login.captcha.required': 'Please input verification code!',
  // 'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  // 'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Keep login status for a certain period',
  // 'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  // 'pages.login.loginWith': 'Login with :',
  // 'pages.login.registerAccount': 'Register Account',

  /** ユーザー一覧 */
  'pages.userlist.item.userid': 'ID',
  'pages.userlist.item.name': 'Name',
  'pages.userlist.item.role': 'Role',
  'pages.userlist.item.available': 'Abailabilry',
  'pages.userlist.item.operation': 'Operation',
  'pages.userlist.availabilty.valid': 'valid',
  'pages.userlist.availabilty.invalid': 'invalid',
  'pages.userlist.button.add': 'ADD',
  'pages.userlist.button.update': 'UPDATE',
  'pages.userlist.button.delete': 'DELETE',
  'pages.userlist.delete.check': 'Delete User ?',
  'pages.userlist.delete.exec': 'Delete User ID:{userid}.',
  'pages.userlist.delete.failed': 'Failed to delete.',

  /** ユーザー登録／編集 */
  'pages.user.item.userid': 'ID',
  'pages.user.item.name': 'Name',
  'pages.user.item.password': 'Password',
  'pages.user.item.confirmpassword': 'Password（confirm）',
  'pages.user.item.role': 'Role',
  'pages.user.item.role.admin': 'Administrator',
  'pages.user.item.role.infouser': 'Notification subscriber',
  'pages.user.item.invalidflag': 'Invalid',
  'pages.user.button.save': 'SAVE',
  'pages.user.button.back': 'BACK',
  'pages.user.userid.required': 'Please input ID.',
  'pages.user.name.required': 'Please input name.',
  'pages.user.role.required': 'Please select role.',
  'pages.user.password.required': 'Please input password.',
  'pages.user.confirmpassword.required': 'Please input password(confirm).',
  'pages.user.password.pattern': 'Please use at least 8 characters and include at least one number, one lowercase letter, and one uppercase letter.',
  'pages.user.password.placeholder': 'Enter only if you want to change.',
  'pages.user.password.mismatch': 'Passwords do not match.',
  'pages.user.userinfo.create': 'Created a user.',
  'pages.user.userinfo.update': 'User information updated.',
  'pages.user.userinfo.save.error': 'Save failed.\n{messages}',

    /** 契約者一覧 */
  'pages.customerlist.item.name': 'Customer name',
  'pages.customerlist.item.schema': 'schema name',
  'pages.customerlist.item.note': 'note',
  'pages.customerlist.item.operation': 'Operation',
  'pages.customerlist.button.add': 'ADD',
  'pages.customerlist.button.update': 'UPDATE',
  'pages.customerlist.button.delete': 'DELETE',
  'pages.customerlist.delete.check': 'Delete Customer ?',
  'pages.customerlist.delete.exec': 'Delete Customer:{userid}.',
  'pages.customerlist.delete.failed': 'Failed to delete.',

  /** 契約者登録／編集 */ 
  'pages.customer.item.customername': 'Customer Name',
  'pages.customer.item.schemaname': 'Schema Name',
  'pages.customer.item.note': 'Note',
  'pages.customer.button.save': 'SAVE',
  'pages.customer.button.back': 'BACK',
  'pages.customer.customername.required': 'Please enter the customer name',
  'pages.customer.schemaname.required': 'Please enter the schema name',
  'pages.customer.schemaname.length': 'Schema name must be within 128 characters',
  'pages.customer.schemaname.validationErr': 'Schema name must be in the format tenant_ followed by three digits (001–999)',
  'pages.customer.customerinfo.create': 'Customer information has been created',
  'pages.customer.customerinfo.update': 'Customer information has been updated',

  // 'pages.welcome.link': 'Welcome',
  // 'pages.welcome.alertMessage':
  //   'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'The page you visited does not exist.',
  'pages.404.buttonText': 'Home',
  // 'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  // 'pages.admin.subPage.alertMessage':
  //   'Umi ui is now released, welcome to use npm run ui to start the experience.',
  // 'pages.searchTable.createForm.newRule': 'New Rule',
  // 'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  // 'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  // 'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  // 'pages.searchTable.updateForm.ruleName.nameRules':
  //   'Please enter the rule name!',
  // 'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  // 'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
  //   'Please enter at least five characters',
  // 'pages.searchTable.updateForm.ruleDesc.descRules':
  //   'Please enter a rule description of at least five characters!',
  // 'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  // 'pages.searchTable.updateForm.object': 'Monitoring Object',
  // 'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  // 'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  // 'pages.searchTable.updateForm.schedulingPeriod.title':
  //   'Set Scheduling Period',
  // 'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  // 'pages.searchTable.updateForm.schedulingPeriod.timeRules':
  //   'Please choose a start time!',
  // 'pages.searchTable.titleDesc': 'Description',
  // 'pages.searchTable.ruleName': 'Rule name is required',
  // 'pages.searchTable.titleCallNo': 'Number of Service Calls',
  // 'pages.searchTable.titleStatus': 'Status',
  // 'pages.searchTable.nameStatus.default': 'default',
  // 'pages.searchTable.nameStatus.running': 'running',
  // 'pages.searchTable.nameStatus.online': 'online',
  // 'pages.searchTable.nameStatus.abnormal': 'abnormal',
  // 'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  // 'pages.searchTable.exception': 'Please enter the reason for the exception!',
  // 'pages.searchTable.titleOption': 'Option',
  // 'pages.searchTable.config': 'Configuration',
  // 'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  // 'pages.searchTable.title': 'Enquiry Form',
  // 'pages.searchTable.new': 'New',
  // 'pages.searchTable.chosen': 'chosen',
  // 'pages.searchTable.item': 'item',
  // 'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  // 'pages.searchTable.tenThousand': '0000',
  // 'pages.searchTable.batchDeletion': 'batch deletion',
  // 'pages.searchTable.batchApproval': 'batch approval',
};
